// extracted by mini-css-extract-plugin
export default {"editor":"styles_editor__ORrNp","modalContainer":"styles_modalContainer__l4074","popup":"styles_popup__JD8xc","popupContent":"styles_popupContent__oRRjm"};